import React from 'react';
import { ReactComponent as AnnotationIndicator } from 'icons/annotation-indicator.svg';

const ANNOTATION_INDICATOR_WIDTH = '20px';
const ANNOTATION_INDICATOR_HEIGHT = '20px';

const OcrCalloutsDropIndicator = ({ position, left, bottom }) => {
  const styleMapping = {
    left: {transform: 'rotate(-90deg)'},
    right: {transform: 'rotate(90deg)'},
    bottom: {transform: 'rotate(180deg)'},
    top: {transform: 'rotate(0deg)'},
  };
  return (
    <div
      id={`callout-drop-indicator-id-${position}`}
      style={{
        display: 'flex',
        position: 'absolute',
        left: left,
        bottom: bottom,
        width: 'fit-content',
        zIndex: 100,
        ...styleMapping[position],
      }}
      className='callout-drop-indicator'
    >
      <AnnotationIndicator
        width={ANNOTATION_INDICATOR_WIDTH}
        height={ANNOTATION_INDICATOR_HEIGHT}
      />
    </div>
  );
};

export default OcrCalloutsDropIndicator;
